import {Box} from '../../../components/core/view';
import {H5Text} from '../../../components/core/text';
import {MainScreens} from '@buncha/navigation/types';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {StyleSheet} from 'react-native';
import {useFontTheme} from '../../../appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';

export interface WIWDisclaimerProps {
  onSignInAgain?: () => void;
}
const WhenIWorkDisclaimer = (props: WIWDisclaimerProps) => {
  const muliFont = useFontTheme('muli');
  const {body} = useGetLocale(Modules.home, MainScreens.Home) ?? {};

  return (
    <Box style={styles.boxContainer}>
      <H5Text
        alignText="left"
        style={[
          styles.mainText,
          {
            fontFamily: muliFont[700].normal,
          },
        ]}>
        {body?.signedOutWIW}
        <H5Text
          onPress={props.onSignInAgain}
          style={[styles.linkText, {fontFamily: muliFont[700].normal}]}>
          {body?.signInAgain}
        </H5Text>
      </H5Text>
    </Box>
  );
};

export default React.memo(WhenIWorkDisclaimer);

const styles = StyleSheet.create({
  linkText: {
    textDecorationLine: 'underline',
  },
  mainText: {
    flex: 1,
  },
  boxContainer: {
    flex: 1,
  },
});
